import { Slider, SliderProps, Stack, Text } from "@mantine/core";
import classes from "./SliderWithLabel.module.css";

type SliderWithLabelProps = {
  label: string;
  /** A CSS font size, e.g. "0.8em" */
  labelFontSize?: string;
  /** A CSS font size, e.g. "0.7em" */
  markLabelFontSize?: string;
  markTooltip?: SliderProps["label"];
} & Omit<SliderProps, "label">;

export const SliderWithLabel = (props: SliderWithLabelProps) => {
  const {
    label,
    labelFontSize,
    markLabelFontSize,
    markTooltip = null,
    ...rest
  } = props;

  return (
    <Stack gap="xs">
      <Text
        className={classes.label}
        style={{ "--label-font-size": labelFontSize }}
      >
        {label}
      </Text>
      <Slider
        mb="lg"
        thumbSize={18}
        size="xs"
        label={markTooltip}
        classNames={{
          track: classes.track,
          mark: classes.mark,
          markLabel: classes.markLabel,
        }}
        style={{ "--mark-label-font-size": markLabelFontSize }}
        {...rest}
      />
    </Stack>
  );
};
